import {inject} from '@angular/core';
import {
  HttpEvent,
  HttpResponse,
  HttpInterceptorFn, HttpRequest, HttpHandlerFn
} from '@angular/common/http';
import {AuthenticationService} from './authentication.service';
import {catchError, of, throwError} from 'rxjs';
import {SessionService} from '../session.service';
import {JwtHelperService} from '@auth0/angular-jwt';
import {environment} from '../../../environments/environment';
import {PlayerAuthenticationService} from '../../modules/player/service/player-authentication.service';
import {PLAYER_PREFIX_FULL} from '../../modules/player/player.routes';
import {Router} from '@angular/router';
import {tap} from 'rxjs/operators';

export const tokenInterceptor: HttpInterceptorFn = (request, next) =>
{
  const auth = inject(AuthenticationService);
  const sessionService = inject(SessionService);
  const authenticationService = inject(AuthenticationService);
  const playerAuthenticationService = inject(PlayerAuthenticationService);
  const router = inject(Router);
  const jwtHelper = new JwtHelperService();

  /* ============================================================
     PLAYER PROFILE / ADMIN API
     ============================================================ */
  if (request.url.startsWith(environment.baseUrlPlayerProfile))
  {
    return handlePlayerProfile(request, next, auth, playerAuthenticationService, sessionService, jwtHelper, router);
  }
  else if (request.url.startsWith(environment.baseUrlPlayerProfile))
  {

  }
  else if (request.url.startsWith('http'))
  {
    let headers = request.headers
      .set('Accept-Language', getLanguageCd(sessionService));

    const token = auth.token;

    if (token)
    {
      headers = headers
        .set('Authorization', `Bearer ${token}`)
        .set('Mandant-Key', String(auth.selectedMandantKey))
        .set('Mandant-Database', auth.selectedMandantDatabase);

      if (sessionService.mandantAssociation)
      {
        if (sessionService.mandantUserSettingSeasonId > 0)
        {
          headers = headers.set(
            'Saison-Id',
            String(sessionService.mandantUserSettingSeasonId)
          );
        }
        if (sessionService.mandantUserSettingRegionId > 0)
        {
          headers = headers.set(
            'Region-Id',
            String(sessionService.mandantUserSettingRegionId)
          );
        }
      }

      // TODO Bald einkommentieren + authenticationService.isAuthenticated
      /*const refreshToken = authenticationService.refreshToken;
      if (refreshToken && jwtHelper.isTokenExpired(token, 1800))  // Halbe Stunde vor Ablauf
        headers = headers.set('Refresh-Token', refreshToken);*/
    }

    request = request.clone({headers});
    /*request = request.clone({
      setHeaders: headers
    });*/

    return next(request).pipe(
      tap((event: HttpEvent<any>) =>
      {
        if (event instanceof HttpResponse)
        {
          const access = event.headers.get('X-Access-Token');
          const refresh = event.headers.get('X-Refresh-Token');

          if (access)
            authenticationService.token = access;
          if (refresh)
            authenticationService.refreshToken = refresh;
        }
      }),
      catchError(response =>
      {
        if (response.status === 401)
        {
          console.log('Nicht mehr angemeldet, url: ' + authenticationService.getUrl());
          authenticationService.proceedLogout(true);
          return of(response);
        }
        return throwError(() => response);
      })
    );
  }

  return next(request);
};

function handlePlayerProfile(
  request: HttpRequest<any>, next: HttpHandlerFn, auth: AuthenticationService,
  playerAuthenticationService: PlayerAuthenticationService, sessionService: SessionService,
  jwtHelper: JwtHelperService, router: Router, ): any
{
  const isAdmin = request.url.includes('/api/v1/admin');
  const token = isAdmin ? auth.token : playerAuthenticationService.token;

  let headers = request.headers.set('Accept-Language', getLanguageCd(sessionService));
  // console.log('PLAYER PROFILE headers', headers);
  if (token)
  {
    headers = headers.set('Authorization', `Bearer ${token}`);

    const refreshToken = playerAuthenticationService.refreshToken;
    if (refreshToken && jwtHelper.isTokenExpired(token, 60))
      headers = headers.set('Refresh-Token', refreshToken);
  }

  request = request.clone({headers});

  return next(request).pipe(
    tap((event: HttpEvent<any>) =>
    {
      if (event instanceof HttpResponse)
      {
        const access = event.headers.get('X-Access-Token');
        const refresh = event.headers.get('X-Refresh-Token');

        if (access)
          playerAuthenticationService.token = access;
        if (refresh)
          playerAuthenticationService.refreshToken = refresh;
      }
    }),
    catchError(response =>
    {
      if (response.status === 401)
      {
        if (isAdmin)
        {
          router.navigate([environment.backendPrefix + '/login?redirect=' + router.url]).then(() => {});
        }
        else
        {
          router.navigate([PLAYER_PREFIX_FULL + '/register']).then(() => {});
          playerAuthenticationService.logoutSuccess();
        }
        return of(response);
      }
      return throwError(() => response);
    })
  );
}

/* ============================================================
   Helper
   ============================================================ */
function getLanguageCd(sessionService: SessionService): string
{
  const cd = sessionService.languageCode;
  return cd === 'de' || cd === 'en' || cd === 'nl' || cd === 'fr' ? cd : 'en';
}

/*@Injectable()
export class TokenInterceptor implements HttpInterceptor
{
  private auth = inject(AuthenticationService);
  private sessionService = inject(SessionService);
  private authenticationService = inject(AuthenticationService);
  private playerAuthenticationService = inject(PlayerAuthenticationService);
  private router = inject(Router);

  jwtHelper: JwtHelperService;

  constructor()
  {
    this.jwtHelper = new JwtHelperService();
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
  {
    console.log('HEADERS', request.headers);
    console.log(
      'refresh-token:',
      request.headers.get('refresh-token')
    );

    // /api/v1/admin/mail/data
    if (request.url.startsWith(environment.baseUrlPlayerProfile))
    {
      const isAdmin = request.url.includes('/api/v1/admin');
      const token = isAdmin ? this.auth.token : this.playerAuthenticationService.token;
      let headers: any;
      if (token)
      {
        headers = {
          'Accept-Language': this.getLanguageCd(),
          Authorization: `Bearer ${token}`,
        };

        const refreshToken = this.playerAuthenticationService.refreshToken;
        if (refreshToken)
        {
          const tokenExpiresSoon = this.jwtHelper.isTokenExpired(token, 60);
          if (tokenExpiresSoon)
            headers['Refresh-Token'] = refreshToken;
          // console.log('Add Refresh Token to header: ', headers);
        }
      }
      else
      {
        headers = {
          'Accept-Language': this.getLanguageCd()
        };
      }

      request = request.clone({
        setHeaders: headers
      });

      console.log('HEADERS 2', request.headers);
      // console.log('Intercept Player Token: ', request);
      return next.handle(request).pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse)
          {
            // console.log('Intercept Response Event', event);
            if (event.headers.has('X-Access-Token'))
            {
              const newToken = event.headers.get('X-Access-Token');
              if (newToken)
                this.playerAuthenticationService.token = newToken;
            }
            if (event.headers.has('X-Refresh-Token'))
            {
              const newRefreshToken = event.headers.get('X-Refresh-Token');
              if (newRefreshToken)
                this.playerAuthenticationService.refreshToken = newRefreshToken;
            }
          }
        }),
        catchError((response: any) => {
          if (response.status === 401)
          {
            console.log('ERROR 401 catched: ', response);
            this.router.navigate([PLAYER_PREFIX_FULL + '/register']).then(() => {});
            this.playerAuthenticationService.logoutSuccess();
            return of(response);
          }
          return throwError(() => response);
        })
      );
    }
    else if (request.url.startsWith('http'))
    {
      // console.log('intercept', request);

      const token = this.auth.token;
      if (token)
      {
        // if (!request.url.endsWith('/refresh'))
        //   this.checkRefreshToken(token);

        const headers = {
          'Accept-Language': this.getLanguageCd(),
          'Mandant-Key': this.auth.selectedMandantKey + '',
          'Mandant-Database': this.auth.selectedMandantDatabase,
          Authorization: `Bearer ${token}`,
        };

        if (this.sessionService.mandantAssociation && this.sessionService.mandantUserSettingSeasonId > 0)
          headers['Saison-Id'] = this.sessionService.mandantUserSettingSeasonId + '';
        if (this.sessionService.mandantAssociation && this.sessionService.mandantUserSettingRegionId > 0)
          headers['Region-Id'] = this.sessionService.mandantUserSettingRegionId + '';

        request = request.clone({
          setHeaders: headers
        });

        return next.handle(request).pipe(
          tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse)
            {
              if (event.headers.has('X-Access-Token'))
              {
                const newToken = event.headers.get('X-Access-Token');
                if (newToken)
                  this.authenticationService.token = newToken;
              }
              if (event.headers.has('X-Refresh-Token'))
              {
                const newRefreshToken = event.headers.get('X-Refresh-Token');
                if (newRefreshToken)
                  this.authenticationService.refreshToken = newRefreshToken;
              }
            }
          }),
          catchError((response: any) => {
            if (response.status === 401)
            {
              console.log('Nicht mehr angemeldet, url: ' + this.authenticationService.getUrl());
              this.router.navigate([environment.backendPrefix + '/login?redirect=' +
                this.authenticationService.getUrl()]).then(() => {});
              return of(response);
            }
            return throwError(() => response);
          })
        );
      }
      else
      {
        request = request.clone({
          setHeaders: {
            'Accept-Language': this.getLanguageCd()
          }
        });
      }
      // console.log('TokenInterceptor: ' + this.auth.token);
    }
    return next.handle(request);
  }

  private getLanguageCd(): string
  {
    const cd = this.sessionService.languageCode;
    if (cd === 'de' || cd === 'en')
      return cd;
    else return 'en'; // Default LanguageCd
  }
}*/

/*private checkRefreshToken(token: string): void
{
  const refreshToken = this.auth.refreshToken;
  if (refreshToken)
  {
    const tokenExpiresSoon = this.jwtHelper.isTokenExpired(token, environment.tokenExpiresSoon);
    // const expiration = this.jwtHelper.getTokenExpirationDate(token);
    if (tokenExpiresSoon)
    {
      // TODO Neues Access-Token erhalten, weil es abläuft
      console.log('Neues Access-Token erhalten, weil es bald abläuft, refreshToken: ' + refreshToken);
      this.auth.generateAccessTokenFromRefreshToken(refreshToken).subscribe({
        next: data =>
        {
          // console.log('generateAccessTokenFromRefreshToken fertig', data);
        },
        error: error =>
        {
          console.log('generateAccessTokenFromRefreshToken error', error);
        }
      });
    }
    // console.log('expiration', expiration);
    // console.log('tokenExpiresSoon: ' + tokenExpiresSoon);
  }
}*/
